module.exports = __webpack_public_path__ + "media/svg-new/file-dc609eee.svg";